import { render, staticRenderFns } from "./product-repeal.vue?vue&type=template&id=0364408c&scoped=true"
import script from "./product-repeal.vue?vue&type=script&lang=js"
export * from "./product-repeal.vue?vue&type=script&lang=js"
import style0 from "./product-repeal.vue?vue&type=style&index=0&id=0364408c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0364408c",
  null
  
)

export default component.exports